import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

const sections = document.querySelectorAll('.imageCallout')

Array.from(sections).forEach((section) => {
    const images = section.querySelector('[data-images]')
    const image1 = section.querySelector('[data-image="1"]')
    const image2 = section.querySelector('[data-image="2"]')
    const image3 = section.querySelector('[data-image="3"]')
    const image4 = section.querySelector('[data-image="4"]')

    const optionsMobile = {
        start: 'top 55%',
        trigger: section,
        scrub: 1,
    }

    const optionsDesktop = {
        start: 'top bottom',
        trigger: section,
        scrub: 1,
    }
    ScrollTrigger.matchMedia({
        '(max-width: 1069px)': () => {
            gsap.to(images, {
                x: '-50%',
                scrollTrigger: optionsMobile,
            })

            // Clear inline styles on unmatch
            return () => gsap.set(images, { clearProps: 'all' })
        },
        '(min-width: 1070px)': () => {
            gsap.fromTo(
                image1,
                {
                    y: '-20%',
                },
                {
                    y: '-50%',
                    scrollTrigger: optionsDesktop,
                }
            )

            gsap.fromTo(
                image2,
                {
                    y: '0',
                },
                {
                    y: '-25%',
                    scrollTrigger: optionsDesktop,
                }
            )

            gsap.fromTo(
                image3,
                {
                    y: '10%',
                },
                {
                    y: '-10%',
                    scrollTrigger: optionsDesktop,
                }
            )

            gsap.fromTo(
                image4,
                {
                    y: '100%',
                },
                {
                    y: '-50%',
                    scrollTrigger: optionsDesktop,
                }
            )

            // Clear inline styles on unmatch
            return () => {
                gsap.set(image1, { clearProps: 'all' })
                gsap.set(image2, { clearProps: 'all' })
                gsap.set(image3, { clearProps: 'all' })
                gsap.set(image4, { clearProps: 'all' })
            }
        },
    })
})
